import React from 'react';
import ExpansionPanel, { ExpansionPanelGroup } from '../../../../lib/expansion_panel';
import ModifyStudyPlanForm from '../../../../organisms/modify_study_plan_form';
import { PremiumBadge } from '@magoosh/lib/info_badges';
import { useUserContext } from '@magoosh/context/user_context';
import { useStudyPlanContext } from '../../context';
import style from '../../style.module.scss';

export const PlanMixExpansionPanel: React.FC = () => {
  const { adaptivePrepData } = useUserContext();
  const { studyPlanState, modifyAndRefreshPlan } = useStudyPlanContext();
  const { settings } = studyPlanState;

  const studyPlanMixName = () => {
    return {
      balanced: 'Balanced Math and Verbal',
      more_math: 'More Math, Less Verbal',
      more_verbal: 'More Verbal, Less Math',
      only_math: 'Only Math',
      only_verbal: 'Only Verbal'
    }[settings.mathAndVerbalMix];
  };

  return (
    <>
      <ExpansionPanelGroup>
        {adaptivePrepData.hasStudyPlan && (
          <ExpansionPanel
            className={style.modifyStudyPlanPanel}
            text={studyPlanMixName()}
            title={
              <span className="d-flex justify-content-between align-items-center">
                <h4>
                  <strong>Modify Your Study Plan</strong>
                </h4>
                {adaptivePrepData.isTrial && <PremiumBadge />}
              </span>
            }>
            {(onClose) => (
              <ModifyStudyPlanForm
                mathAndVerbalMix={settings.mathAndVerbalMix}
                shouldIncludeWriting={settings.shouldIncludeWriting}
                onClose={onClose}
                onSubmit={modifyAndRefreshPlan}
              />
            )}
          </ExpansionPanel>
        )}
      </ExpansionPanelGroup>
    </>
  );
};

export default PlanMixExpansionPanel;
